/**
 * JU!CE — Gerenciador global de sabor ativo.
 *
 * Fonte da verdade por template:
 * - PDP / Carrinho: snippets/jp-flavor-key.liquid já escreve o data-flavor certo
 *   no <body> a partir do produto real (ou do 1º item do carrinho). Aqui a
 *   gente NUNCA sobrescreve isso com o localStorage — só sincroniza o
 *   localStorage com o que o Liquid mandou, pra a home lembrar do último
 *   sabor visto.
 * - Home / Coleção / Página (body.template-index | template-collection |
 *   template-page): não há produto "dono" do sabor, então aplicamos o que
 *   estiver salvo em localStorage('jp-flavor') por cima do default do Liquid.
 * - Qualquer página: escuta 'jp:flavor-change' (disparado pelo seletor de
 *   sabor da hero — CustomEvent com detail = 'uva' ou { flavor: 'uva' }) e
 *   troca o body[data-flavor] na hora, com transição (.jp-flavor-transition,
 *   já definida em assets/jp-base.css) e persistindo em localStorage — a menos
 *   que o evento venha com detail.persist === false (troca automática da hero,
 *   que muda a tela mas não vira preferência do visitante).
 *
 * API pública: window.jpFlavor.get() / window.jpFlavor.set(key, { persist }).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'jp-flavor';
  var TRANSITION_CLASS = 'jp-flavor-transition';
  var TRANSITION_MS = 600;

  // Templates onde o Liquid é dono do sabor (produto real / carrinho) — aqui
  // a gente só lê e sincroniza o storage, nunca sobrescreve o body.
  var LIQUID_OWNED_TEMPLATES = ['template-product', 'template-cart'];

  // Templates onde o localStorage pode aplicar o sabor lembrado do visitante.
  var STORAGE_APPLIES_TEMPLATES = ['template-index', 'template-collection', 'template-page'];

  var FLAVOR_NAMES = {
    tangerina: 'Tangerina',
    uva: 'Uva',
    vermelhas: 'Frutas Vermelhas',
    tropicais: 'Frutas Tropicais',
    'abacaxi-hortela': 'Abacaxi com Hortelã'
  };

  function bodyHasClass(list) {
    var classList = document.body.classList;
    for (var i = 0; i < list.length; i++) {
      if (classList.contains(list[i])) return true;
    }
    return false;
  }

  function isLiquidOwned() {
    return bodyHasClass(LIQUID_OWNED_TEMPLATES);
  }

  function storageAllowed() {
    return bodyHasClass(STORAGE_APPLIES_TEMPLATES);
  }

  function readStored() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function writeStored(key) {
    try {
      window.localStorage.setItem(STORAGE_KEY, key);
    } catch (e) {
      /* Storage bloqueado (privado/Safari): segue só na sessão. */
    }
  }

  function updateFlavorNames(key) {
    var name = FLAVOR_NAMES[key];
    if (!name) return;
    var nodes = document.querySelectorAll('[data-flavor-name]');
    nodes.forEach(function (node) {
      node.textContent = name;
    });
  }

  function applyFlavor(key, options) {
    if (!key || !FLAVOR_NAMES[key]) return;
    options = options || {};
    var body = document.body;
    var isNew = body.dataset.flavor !== key;

    if (isNew) {
      body.classList.add(TRANSITION_CLASS);
      body.dataset.flavor = key;
      window.setTimeout(function () {
        body.classList.remove(TRANSITION_CLASS);
      }, TRANSITION_MS);
      document.dispatchEvent(new CustomEvent('jp:flavor-changed', { detail: { flavor: key } }));
    }

    updateFlavorNames(key);

    if (options.persist !== false) {
      writeStored(key);
    }
  }

  function parseEventKey(event) {
    var detail = event && event.detail;
    if (typeof detail === 'string') return detail;
    if (detail && typeof detail === 'object') {
      return detail.flavor || detail.key || detail.value || null;
    }
    return null;
  }

  /*
   * detail.persist === false => troca automática (passeio de sabores da hero,
   * assets/jp-motion.js): aplica na tela, mas NÃO grava no localStorage. O
   * sabor lembrado é sempre o que a pessoa escolheu clicando. Sem a flag
   * (evento antigo ou detail string), o padrão continua sendo persistir.
   */
  function onFlavorChangeEvent(event) {
    var key = parseEventKey(event);
    if (!key) return;
    var detail = event && event.detail;
    var persist = !(detail && typeof detail === 'object' && detail.persist === false);
    applyFlavor(key, { persist: persist });
  }

  function init() {
    updateFlavorNames(document.body.dataset.flavor);

    if (isLiquidOwned()) {
      // PDP/carrinho mandam. Só guarda pra próxima visita à home lembrar.
      var current = document.body.dataset.flavor;
      if (current) writeStored(current);
    } else if (storageAllowed()) {
      var stored = readStored();
      if (stored && FLAVOR_NAMES[stored] && stored !== document.body.dataset.flavor) {
        applyFlavor(stored, { persist: false });
      }
    }

    document.addEventListener('jp:flavor-change', onFlavorChangeEvent);
  }

  window.jpFlavor = {
    get: function () {
      return document.body.dataset.flavor || null;
    },
    set: function (key, options) {
      applyFlavor(key, options);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
